import { memo } from 'react'
import { Divider } from 'antd'
import MicAction from './actions/MicAction'
import VideoUpload from './actions/VideoUpload'
import AudioUpload from './actions/AudioUpload'
import ImageUpload from './actions/ImageUpload'
import DocUpload from './actions/DocUpload'

const ActionBar = () => {
  return (
    <div className="justify-between items-center text-xs hidden md:flex">
      <div className="flex flex-1 items-center gap-2">
        <ImageUpload />
        <AudioUpload />
        <DocUpload />
        <VideoUpload />
        <Divider className="mx-1 h-3" type="vertical" />
        <MicAction />
      </div>
    </div>
  )
}

export default memo(ActionBar)
